/**
 * Central de suporte (`/suporte`). A lista de perguntas sai igual na tela e
 * no `FAQPage` do JSON-LD. Fatos: cadastro (`app/(auth)/register.tsx`,
 * WhatsApp/e-mail/Google/Apple), botão "Esqueci a senha" (`login.tsx`),
 * recursos pagos (`content/facts.ts`), cancelamento por loja
 * (`app/subscription/plans.tsx`).
 */
import { COMPANY, FREE_PLAN } from '../facts';

export const SUPPORT_PATH = '/suporte';
export const SUPPORT_TITLE = 'Central de suporte';
export const SUPPORT_DESCRIPTION =
  `Suporte da Controlapag por e-mail, ${COMPANY.supportHours}: como criar a conta, recuperar a senha, cadastrar clientes e cancelar a assinatura.`;
export const SUPPORT_INTRO = `O suporte da Controlapag é por e-mail, ${COMPANY.supportHours} (horário de Brasília), com resposta em ${COMPANY.supportResponse}. As dúvidas mais comuns estão abaixo.`;

export interface SupportFaqItem {
  question: string;
  answer: string;
}

export const SUPPORT_FAQ: SupportFaqItem[] = [
  {
    question: 'Como criar minha conta?',
    answer: `Na tela de criar conta, no app ou no site, escolha entrar pelo WhatsApp, por e-mail, com Google ou com Apple. A conta grátis atende até ${FREE_PLAN.maxClientsPerMonth} clientes por mês, sem prazo, com agenda e cobranças avulsas.`,
  },
  {
    question: 'Esqueci minha senha. O que faço?',
    answer:
      'Na tela de entrar, toque em "Esqueci a senha", informe o e-mail da conta e siga o link que chega no seu e-mail. Se a conta foi criada pelo WhatsApp, entre de novo pelo WhatsApp com o código.',
  },
  {
    question: 'Como cadastrar clientes e cobranças?',
    answer:
      'Depois de entrar, use Clientes para adicionar cada pessoa e Contratos para definir o serviço e o valor. A cobrança avulsa é grátis. A cobrança recorrente (mensalidade ou assinatura do cliente) faz parte dos planos pagos.',
  },
  {
    question: 'Como o cliente me paga?',
    answer:
      'Por padrão, o cliente paga direto a você e você toca em "Confirmar recebimento" na cobrança. Nos planos pagos, ele também pode pagar pelo link, com Pix, cartão ou boleto, com taxa por pagamento.',
  },
  {
    question: 'Como cancelar a assinatura?',
    answer:
      'Depende de onde você assinou. No site, escreva para o e-mail do suporte, ou exclua a conta, que cancela na hora. No iPhone, cancele na App Store, em Ajustes › seu nome › Assinaturas. No Android, cancele no Google Play, em Pagamentos e assinaturas. Excluir a conta não cancela assinatura da App Store nem do Google Play.',
  },
  {
    question: 'Meus dados estão seguros?',
    answer:
      'Usamos conexão criptografada, senha guardada de forma embaralhada e acesso separado por conta, e não vendemos dados. Nenhum serviço na internet é livre de falha: a política de privacidade explica o que coletamos, com quem compartilhamos e como pedir a exclusão.',
  },
  {
    question: 'Como excluir minha conta?',
    answer:
      'No app ou no site, em Perfil › Excluir conta. A exclusão é na hora e apaga dados e arquivos da conta. O que a lei manda guardar, e por quanto tempo, está na página de exclusão de conta.',
  },
];
